import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { FCWithFragments } from '@modernloop/shared/components';

import { ZoomHealthCheckBanner_ZoomFragment } from 'src/generated/mloop-graphql';

import AppWideBanner, { AppWideBannerAction } from '../AppWideBanner';

interface Fragments {
  zoom: ZoomHealthCheckBanner_ZoomFragment;
}

interface Props {
  retry: AppWideBannerAction;
}

const ZoomHealthCheckBanner: FCWithFragments<Fragments, Props> = ({ zoom, retry }) => {
  const { t } = useTranslation();
  // hide if its not installed or is healthy
  if (!zoom || !zoom?.isInstalled || zoom?.isHealthy) {
    return null;
  }

  return (
    <AppWideBanner
      color="foreground"
      backgroundColor="error"
      text={t('hiring-dashboard-nav:nav.banner.integrationUnhealthy', { integrationName: 'Zoom' })}
      action={retry}
    />
  );
};

ZoomHealthCheckBanner.fragments = {
  zoom: gql`
    fragment ZoomHealthCheckBanner_zoom on ZoomIntegrationHealth {
      isHealthy
      isInstalled
    }
  `,
};

export default ZoomHealthCheckBanner;
